import React, { useEffect, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, CircularProgress } from "@mui/material";
import CustomPagination from "../../components/pagination";
import { useNavigate } from "react-router-dom";
import { staticAssumptionService } from "../../utils/services/staticAssumptionService";
import StaticAssumptionList from "../../components/static-assumption-list";
import StaticAssumptionModal from "../../components/static-assumption-modal";
import buildQuery from "../../utils/query-builder";

const StaticAssumption = () => {
  const [selectedData, setSelectedData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [staticAssumptionList, setStaticAssumptionList] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [openStaticAssumptionModal, setOpenStaticAssumptionModal] =
    useState(false);

  const fetchStaticAssumption = async () => {
    setLoading(true);
    try {
      const response = await staticAssumptionService.fetch(
        null,
        buildQuery({ limit: rowsPerPage, skip: page * rowsPerPage }),
      );
      setStaticAssumptionList(response.data);
      setLoading(false);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaticAssumption();
  }, [page, rowsPerPage]);

  return (
    <>
      <DashboardContainer
        filterButton={false}
        hideUploadButton
        header={"Static Assumption"}
        title={"+ Static Assumption"}
        onClickAddButton={() => setOpenStaticAssumptionModal(true)}
        setViewMode={setViewMode}
        hideFilterClient={true}
        onClickRefresh={() => fetchStaticAssumption()}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <StaticAssumptionList
            dataCount={dataCount}
            currentPage={page}
            itemsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            onDeleteData={fetchStaticAssumption}
            onEditData={(e) => {
              setSelectedData(e);
              setOpenStaticAssumptionModal(true);
            }}
            data={staticAssumptionList}
            viewMode={viewMode}
            selectedStaticAssumption={selectedData}
            setSelectedStaticAssumption={setSelectedData}
          />
        )}
      </DashboardContainer>
      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
      <StaticAssumptionModal
        open={openStaticAssumptionModal}
        onClose={() => {
          setOpenStaticAssumptionModal(false);
          setSelectedData(null);
        }}
        editData={selectedData}
        onSuccess={() => {
          fetchStaticAssumption();
          setSelectedData(null);
        }}
      />
    </>
  );
};

export default StaticAssumption;
